import { ListElement } from "./styled"

export const currentSkillset = [
    { skill: "React" },
    { skill: "Redux (Toolkit)" },
    { skill: "Redux Saga" },
    { skill: "Working with API (fetch, axios)" },
    { skill: "Semantic & accessible HTML" },
    { skill: "React Hooks" },
    { skill: "Error Handling" },
    { skill: "GitHub Pull Requests & Review" },
    { skill: "JavaSrcipt: ES6+" },
    { skill: "Scrum" },
    { skill: "NPM" },
    { skill: "Tailwind CSS" },
    { skill: "React Query (TanStack)"},
    { skill: "Git" },
    { skill: "Responsive Web Design" },
    { skill: "Teamwork" },
    { skill: "Markdown" },
    { skill: "Immutability" },
    { skill: "CSS BEM convention" },
    { skill: "CSS BEM convention" },
    { skill: "CSS Grid" },
    { skill: "CSS Flexbox" },
    { skill: "Trello" },
];

export const wantToLearn = [
    { skill: "React Context" },
    { skill: "Node.js" },
    { skill: "Cypress" },
    { skill: "Unit testing" },
    { skill: "TypeScript" },
    { skill: "JS classes" },
]